import * as React from 'react'

function SvgCondenserWashIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M25.2 4.2h-2.7l-1.92-2.7C19.92.57 18.81 0 17.64 0H9.36C8.19 0 7.11.57 6.42 1.5L4.5 4.2H1.8C.81 4.2 0 5.01 0 6v19.2c0 .99.81 1.8 1.8 1.8h23.4c.99 0 1.8-.81 1.8-1.8V6c0-.99-.81-1.8-1.8-1.8zM7.38 2.19c.45-.63 1.17-.99 1.95-.99h8.31c.78 0 1.5.36 1.95.99l1.44 2.01H5.97l1.41-2.01zM1.2 6c0-.33.27-.6.6-.6h11.1v16.8H1.2V6zm24.6 19.2c0 .33-.27.6-.6.6H1.8c-.33 0-.6-.27-.6-.6v-1.8h24.6v1.8zm0-3H14.1V5.4h11.1c.33 0 .6.27.6.6v16.2z"
        fill="currentColor"
      />
      <path
        d="M5.1 8.4h5.4c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6H5.1C3.93 7.2 3 8.13 3 9.3s.93 2.1 2.1 2.1H9c.51 0 .9.39.9.9 0 .48-.39.9-.9.9H5.1c-1.17 0-2.1.93-2.1 2.1s.93 2.1 2.1 2.1H9c.51 0 .9.39.9.9 0 .48-.39.9-.9.9H3.6c-.33 0-.6.27-.6.6 0 .33.27.6.6.6H9c1.17 0 2.1-.93 2.1-2.1s-.93-2.1-2.1-2.1H5.1c-.51 0-.9-.42-.9-.9 0-.51.39-.9.9-.9H9c1.17 0 2.1-.93 2.1-2.1s-.93-2.1-2.1-2.1H5.1c-.51 0-.9-.42-.9-.9 0-.51.39-.9.9-.9zM18 11.4h3.9c1.17 0 2.1-.93 2.1-2.1s-.93-2.1-2.1-2.1h-5.4c-.33 0-.6.27-.6.6 0 .33.27.6.6.6h5.4c.51 0 .9.39.9.9 0 .48-.39.9-.9.9H18c-1.17 0-2.1.93-2.1 2.1s.93 2.1 2.1 2.1h3.9c.51 0 .9.39.9.9 0 .48-.39.9-.9.9H18c-1.17 0-2.1.93-2.1 2.1s.93 2.1 2.1 2.1h5.4c.33 0 .6-.27.6-.6 0-.33-.27-.6-.6-.6H18c-.51 0-.9-.42-.9-.9 0-.51.39-.9.9-.9h3.9c1.17 0 2.1-.93 2.1-2.1s-.93-2.1-2.1-2.1H18c-.51 0-.9-.42-.9-.9 0-.51.39-.9.9-.9z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgCondenserWashIcon
